import IFellowshipPost from "../interfaces/IFellowshipPost";
import PostTypes, { PostTypesValues } from "./PostTypes";

export const EmptyPostObject = (): IFellowshipPost => {
  const currentDate = new Date(Date.now());
  return {
      id: 'unknown',
      userId: 'unknown',
      groupId: '6YoLqzQegHoYFdJsvbDU',
      linkedPostId: '',
      type: PostTypes.fellowship,
      author: 'unknown',
      title: 'untitled',
      postText: 'post message',
      prayingTotal: 0,
      commentsTotal: 0,
      likesTotal: 0,
      likesUserIds: [],
      prayingUserIds: [],
      comments: [],
      createdDate: currentDate,
      modifiedDate: currentDate,
      sortDate: currentDate,
      hidden: false,
    }
}

export const CreatePostObject = (
  postProps: {
    id: string, 
    userId: string, 
    groupId: string, 
    author: string, 
    title: string, 
    postText: string, 
    type: PostTypesValues
  }): IFellowshipPost => {
    return {...EmptyPostObject(), ...postProps};
}